<template>
  <div class="background-image">
    <div class="content-wrap">
      <!-- 左侧轮播图区域 -->
      <div class="content-view" style="border-bottom-left-radius: 10px; border-top-left-radius: 10px;">
        <!-- <el-carousel  class="carousel-element"> -->
          <!-- <el-carousel-item v-for="item in adList" :key="item" @click.native="adClick(item)"> -->
            <img src="../../../assets/image/new_slices/zhuanjia.jpg" alt="" style="width: 100%; height: 100%;">
          <!-- </el-carousel-item> -->
        <!-- </el-carousel> -->
      </div>
      <!-- 右侧登录区域 -->
      <div class="content-view">
        <div class="login-container">
          <!-- 返回首页链接 -->
          <div class="return-home">
            <a href="/todayEvaluation" class="return-link">返回首页</a>
          </div>
          <!-- 标题 -->
          <div class="login-title">
            <div class="main-title">欢迎登录专家评标系统</div>
          </div>
          <!-- 登录表单 -->
          <div class="login-form">
            <!-- 姓名输入 -->
            <div class="form-group">
              <div class="input-wrapper">
                <input type="text" placeholder="请输入姓名" class="form-input" v-model="loginForm.name">
              </div>
            </div>
            <!-- 身份证号输入 -->
            <div class="form-group">
              <div class="input-wrapper">
                <input type="text" placeholder="请输入身份证号" class="form-input" v-model="loginForm.password">
              </div>
            </div>
              <!-- 评标密码 -->
             <div class="form-group">
              <div class="input-wrapper">
                <input type="text" placeholder="请输入数字认证验证码" class="form-input" v-model="loginForm.pin">
              </div>
            </div>
            <!-- 登录按钮 -->
            <button class="login-btn" @click="handleLogin">登录</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 信息确认弹窗 -->
    <el-dialog title="信息" :visible.sync="showConfirmDialog" width="500px" :close-on-click-modal="true" :show-close="false"
      :close-on-press-escape="true" custom-class="info-confirm-dialog">
      <el-form :model="confirmForm" label-width="120px" size="small" style="text-align: start;">
        <el-form-item label="姓名：">
          <span class="info-value">{{ expertInfo.realName }} </span>
        </el-form-item>
        <el-form-item label="单位：">
          <span class="info-value">{{ expertInfo.company }}</span>
        </el-form-item>
        <el-form-item label="项目编码：">
          <span class="info-value">{{ expertInfo.projectCode }}</span>
        </el-form-item>
        <el-form-item label="项目名称：">
          <span class="info-value">{{ expertInfo.projectName }}</span>
        </el-form-item>
        <el-form-item label-width="40px">
          <el-checkbox v-model="identityConfirmed" @change="handleCheckboxChange">
            身份确认
          </el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmLogin">确认</el-button>
      </div>
    </el-dialog>
    <!-- 推荐组长弹窗 -->
    <div v-if="showRecommendDialog" class="recommend-dialog-overlay">
      <div class="recommend-dialog" @click.stop>
        <div class="recommend-dialog-content">
          <!-- 标题栏 -->
          <div class="recommend-dialog-header">
            <div class="title-section">
              <div class="title-bar"></div>
              <h3 class="dialog-title">推荐组长</h3>
            </div>
            <button class="new-file-btn" @click="showPreview">预览文件</button>
          </div>
          <!-- 提示文字 -->
          <div class="instruction-text">
            请选择你要推荐的组长:
          </div>

          <!-- 选择选项 -->
          <div class="selection-options">
            <div class="expert-card" v-for="expert in expertList" :key="expert.expertId"
              :class="{ active: selectedLeader === expert.expertId }" @click="selectLeader(expert.expertId)">
              <div class="expert-info">
                <div class="expert-name">{{ expert.expertName }}</div>
                <div class="expert-details">
                  <div class="expert-unit">工作单位：{{ expert.company }}</div>
                  <div class="expert-title">职称：{{ expert.professionalTitle }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 保存按钮 -->
          <div class="save-section">
            <button class="save-btn" @click="saveRecommendation">保存</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 推荐结果弹窗 -->
    <div v-if="showResultDialog" class="result-dialog-overlay">
      <div class="result-dialog" @click.stop>
        <div class="result-dialog-content">
          <!-- 标题栏 -->
          <div class="result-dialog-header">
            <div class="title-section">
              <div class="title-bar"></div>
              <h3 class="dialog-title">推荐组长</h3>
            </div>
          </div>

          <!-- 候选人展示 -->
          <div class="candidates-section">
            <div class="candidate-item" v-for="expert in voteResult" :key="expert.voteForExpertId">
              <div class="candidate-name">{{ expert.voteForExpertName }}</div>
              <div class="vote-count">票数: {{ expert.voteCount || 0 }}</div>
            </div>
          </div>

          <!-- 投票结果 -->
          <div class="vote-result">
            <div class="result-text">
              根据投票结果,组长为:{{ complete == 0 ? "正在投票.." : selectedLeaderName }}
            </div>
          </div>

          <!-- 开始评标按钮 -->
          <div class="start-section">
            <button class="start-btn" @click="startEvaluation">开始评标</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 预览文件弹窗 -->
    <div v-if="showPreviewDialog" class="preview-dialog-overlay">
      <div class="preview-dialog" @click.stop>
        <div class="preview-dialog-content">
          <!-- 标题栏 -->
          <div class="preview-dialog-header">
            <div class="title-section">
              <div class="title-bar"></div>
              <h3 class="dialog-title">预览文件</h3>
            </div>
            <!-- 操作按钮 -->
            <div class="preview-actions">
              <button class="recommend-btn" @click="handleRecommend">
                人员到齐，推选组长
              </button>
            </div>
          </div>

          <!-- 文件选择区域 -->
          <div class="file-selection-section">
            <div class="selection-row">
              <span class="selection-label">选择要预览的文件:</span>
              <el-radio-group v-model="selectedFileType" class="file-radio-group">
                <el-radio label="bidding">招标文件</el-radio>
                <el-radio label="tender">投标文件</el-radio>
              </el-radio-group>
              <el-select v-model="selectedCompany" class="company-select" placeholder="选择公司"
                @change="handleBidderChange">
                <el-option v-for="item in bidderOptions" :key="item.userId" :label="item.userName"
                  :value="item.userId"></el-option>
              </el-select>
            </div>
          </div>

          <!-- 预览区域 -->
          <div class="preview-content">
            <PdfViewer :pdf-url="getPdfUrl()" :show-toolbar="true" :initial-scale="1.0" @pdf-loaded="onPdfLoaded"
              @pdf-error="onPdfError" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  expertLogin,
  getBidderList,
  getBidderFile,
  getEvaluationExpertList,
  getVoteBidder,
  getComplete,
  saveComplete,
  getVoteResult,
  getExpertById
} from '@/api/evaluation/api'
import {
  getInvitationMain
} from '@/api/make/api'
import Cookies from 'js-cookie'
import PdfViewer from '@/components/common/PdfViewer.vue'

export default {
  name: 'ExpertLogin',
  components: {
    PdfViewer
  },
  data() {
    return {
      // 广告图片
      adList: [
        "https://www.hbidding.com/upload/admanage/2021-06/1623832733354.jpg",
        "https://www.hbidding.com/upload/admanage/2023-12/1702025731158.png"
      ],
      // 登录表单
      loginForm: {
        name: '',
        password: '',
        captcha: '',
        pin:'',

      },
      showPreviewDialog: false,//预览文件弹窗
      showConfirmDialog: false,//信息确认弹窗
      identityConfirmed: false,//身份确认
      showRecommendDialog: false,//推荐组长弹窗
      showResultDialog: false,//推荐结果弹窗
      confirmForm: {},//确认表单
      selectedLeader: null,// 选中的组长
      selectedFileType: 'bidding',// 文件类型
      selectedCompany: '1',
      pdfUrl: '', // 添加PDF URL存储
      expertList: [],// 推荐组长专家列表
      bidderOptions: [], // 投标单位列表
      voteResult: [],// 投票结果
      voteResultTimer: null, // 投票结果定时器
      expertListTimer: null, // 专家列表定时器
      complete: 0,//投票是否结束
      selectedLeaderName: '',//组长名称
      expertInfo: {},// 专家数据

    }
  },

  watch: {
    // 监听文件类型变化，重新获取PDF
    selectedFileType(newType) {
      this.refreshPdfUrl()
    }
  },
  beforeDestroy() {
    // 页面销毁时清除定时器
    this.clearVoteResultTimer()
    this.clearExpertListTimer()
  },
  methods: {
    // 选择投标单位
    handleBidderChange(value) {
      this.selectedCompany = value
      this.refreshPdfUrl()
    },
    // 根据当前状态刷新PDF URL
    refreshPdfUrl() {
      if (this.selectedFileType === 'bidding') {
        // 获取招标文件
        this.getInvitationMain()
      } else {
        // 获取投标文件
        this.getBidderFile()
      }
    },


    // 处理登录
    handleLogin() {
      // 表单验证
      if (!this.loginForm.name) {
        this.$message.error('请输入姓名')
        return
      }
      if (!this.loginForm.password) {
        this.$message.error('请输入身份证号')
        return
      }
      this.expertLogin()
    },
    // 专家登录 
    expertLogin() {
      expertLogin({
        idCard: this.loginForm.password,
        loginName: this.loginForm.name,
        captchaCodeUuId: "",
        captchaCode: this.loginForm.captcha,
        sectionCode: Cookies.get('bidSectionCode'),
        committeeId: Cookies.get('committeeId'),
        pin: this.loginForm.pin,
        pinEnsure: this.loginForm.pin

      }).then(res => {
        if (res.code === 200) {
          if (res.data.token) {
            Cookies.set('token', res.data.token)
            Cookies.set('evaluationId', res.data.evaluationId)
            this.getComplete()
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('登录失败:', err)
      })
    },
    // 获取完成到哪一步
    getComplete() {
      let data = {
        committeeId: Cookies.get('committeeId'),
        expertId: Cookies.get('evaluationId')
      }
      getComplete(data).then(res => {
        if (res.code === 200) {
          if (res.data) {
            switch (res.data.complete) {
              case 1:
                this.startVoteResultTimer()
                this.showResultDialog = true
                break;
              case 2:
                this.showConfirmDialog = true
                this.getExpertById()
                break;
              case 3:
                this.$router.push('/expertEvaluation')
                break;
              default:
                this.startExpertListTimer()
                break;
            }
          } else {
            this.startExpertListTimer()
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取评标室专家列表
    getEvaluationExpertList() {
      getEvaluationExpertList(Cookies.get('committeeId')).then(res => {
        if (res.code === 200) {
          if (res.data.length > 0) {
            this.showRecommendDialog = true
            this.expertList = res.data
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 启动专家列表定时器（5秒轮询）
    startExpertListTimer() {
      // 先清除已存在的定时器，避免重复
      this.clearExpertListTimer()
      // 立即执行一次
      this.getEvaluationExpertList()
      // 设置定时器每5秒执行一次
      this.expertListTimer = setInterval(() => {
        console.log('-----执行了一次');
        
        this.getEvaluationExpertList()
      }, 5000)
    },

    
    // 清除专家列表定时器
    clearExpertListTimer() {
      if (this.expertListTimer) {
        clearInterval(this.expertListTimer)
        this.expertListTimer = null
      }
    },

    // 关闭弹窗
    closeDialog() {
      this.showConfirmDialog = false
      this.identityConfirmed = false
    },
    // 预览文件
    showPreview() {
      this.showPreviewDialog = true
      this.showRecommendDialog = false
      this.getBidderList()
    },
    //  获取投标文件列表
    getBidderList() {
      getBidderList().then(res => {
        if (res.code === 200) {
          if (res.data.length > 0) {
            this.selectedCompany = res.data[0].userId
            this.refreshPdfUrl()
          }
          this.bidderOptions = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 根据userId和标段编码，获取投标文件
    getBidderFile() {
      getBidderFile({
        userId: this.selectedCompany,
        sectionCode: Cookies.get('bidSectionCode'),
      }).then(res => {
        if (res.code === 200) {
          this.pdfUrl = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //招标-获取文件正文 
    getInvitationMain() {
      getInvitationMain(Cookies.get('bidSectionCode')).then(res => {
        if (res.code === 200) {
          this.pdfUrl = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 关闭预览文件弹窗
    closePreviewDialog() {
      this.showPreviewDialog = false
    },
    // 选择文件类型
    selectFileType(type) {
      this.selectedFileType = type
    },

    // 获取预览文本
    getPreviewText() {
      if (this.selectedFileType === 'bidding') {
        return '招标文件'
      } else {
        return '投标文件'
      }
    },

    // 处理推选操作
    handleRecommend() {
      this.showPreviewDialog = false
      this.showRecommendDialog = true
    },

    // 获取PDF文件URL
    getPdfUrl() {
      return this.pdfUrl || ''
    },

    // PDF加载完成回调
    onPdfLoaded(info) {
      console.log('PDF加载完成:', info)
    },

    // PDF加载错误回调
    onPdfError(error) {
      console.error('PDF加载失败:', error)
      this.$message.error('PDF文件加载失败')
    },
    // 确认登录
    confirmLogin() {
      if (!this.identityConfirmed) {
        this.$message.warning('请先确认身份信息')
        return
      }
      // 关闭弹窗
      this.showConfirmDialog = false
      // 跳转到评标页面
      this.$router.push('/expertEvaluation')
    },

    // 广告点击处理
    adClick(item) {
      console.log('广告点击:', item)
    },
    // 选择组长
    selectLeader(expertId) {
      this.selectedLeader = expertId
    },
    // 保存推荐
    saveRecommendation() {
      if (!this.selectedLeader) {
        this.$message.warning('请选择要推荐的组长')
        return
      }
      this.recommendLeader()
    },
    // 推荐组长接口
    recommendLeader() {
      getVoteBidder({
        committeeId: Cookies.get('committeeId'),
        voteExpertId: Cookies.get('evaluationId'),
        voteForExpertId: this.selectedLeader,
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('推荐成功')
          // 清除专家列表定时器，避免定时器继续触发导致弹窗重新打开
          this.clearExpertListTimer()
          this.showRecommendDialog = false
          this.startVoteResultTimer()
          this.showResultDialog = true
          this.saveComplete(1)
        } else {
          this.clearVoteResultTimer()
          this.startExpertListTimer()
          this.showResultDialog = false;
          this.$message.error(res.msg)
        }
      })
    },
    // 获取投票结果详情
    getVoteResult() {
      getVoteResult({
        committeeId: Cookies.get('committeeId'),
      }).then(res => {
        if (res.code === 200) {
          this.voteResult = res.data.detail
          this.complete = res.data.complete
          this.selectedLeaderName = res.data.max.voteForExpertName
          if (this.complete === 1) {
            this.clearVoteResultTimer()
          }
        } else {
          this.clearVoteResultTimer()
          this.startExpertListTimer()
          this.showResultDialog = false;
          this.$message.error(res.msg)
        }
      })
    },
    // 关闭推荐弹窗
    closeRecommendDialog() {
      this.showRecommendDialog = false
      this.selectedLeader = null
    },
    // 关闭结果弹窗
    closeResultDialog() {
      this.showResultDialog = false
      // 关闭弹窗时停止定时器
      this.clearVoteResultTimer()
    },
    // 开始评标
    startEvaluation() {
      if (this.complete === 0) {
        this.$message.warning('投票未完成～')
        return
      }
      this.saveComplete(2)
      this.showResultDialog = false
      this.showConfirmDialog = true
      this.identityConfirmed = false
      this.getExpertById()
    },
    //  根据id获取专家信息
    getExpertById() {
      getExpertById(Cookies.get('evaluationId')).then(res => {
        if (res.code === 200) {
          this.expertInfo = res.data
          this.expertInfo.projectName = Cookies.get('projectName')
          this.expertInfo.projectCode = Cookies.get('projectCode')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 启动投票结果定时器
    startVoteResultTimer() {
      // 先清除已存在的定时器
      this.clearVoteResultTimer()
      // 立即执行一次
      this.getVoteResult()
      // 设置定时器每10秒执行一次
      this.voteResultTimer = setInterval(() => {
        this.getVoteResult()
      }, 10000)
    },
    // 清除投票结果定时器
    clearVoteResultTimer() {
      if (this.voteResultTimer) {
        clearInterval(this.voteResultTimer)
        this.voteResultTimer = null
      }
    },
    //身份确认
    handleCheckboxChange(value) {
      if (value) {
        this.saveComplete(3)
      } else {
        this.saveComplete(2)
      }
    },
    // 保存步骤
    saveComplete(vl) {
      saveComplete({
        committeeId: Cookies.get('committeeId'),
        expertId: Cookies.get('evaluationId'),
        complete: vl,
      }).then(res => {
        if (res.code === 200) {
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.background-image {
  height: 100vh;
  background-image: url('../../../assets/image/new_slices/lgin_bg@2x.jpg');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;

  .content-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    .content-view {
      width: 490px;
      height: 603px;
      background: #fff;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      position: relative;

      .carousel-element {
        height: 603px;

        :deep(.el-carousel__item) {
          height: 603px;
        }
      }

      .login-container {
        padding: 30px 40px;
        height: 100%;
        display: flex;
        flex-direction: column;

        .return-home {
          display: flex;
          text-align: right;
          justify-content: flex-end;
          align-items: center;

          .return-link {
            color: #666;
            text-decoration: none;
            font-size: 14px;
          }
        }

        .login-title {
          text-align: center;
          margin-bottom: 49px;
          margin-top: 35px;

          .main-title {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin-bottom: 8px;
          }

        }

        .login-form {
          flex: 1;
          display: flex;
          flex-direction: column;

          .form-group {
            margin-bottom: 20px;

            .input-wrapper {
              display: flex;
              align-items: center;
              position: relative;

      

              .form-input {
                flex: 1;
                height: 45px;
                border: 1px solid #ddd;
                border-radius: 4px;
                padding: 0 15px;
                font-size: 14px;
                box-sizing: border-box;
                outline: none;
                transition: border-color 0.3s ease, box-shadow 0.3s ease;

                &:focus {
                  border-color: #409EFF;
                  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                }

                &::placeholder {
                  color: #999;
                }
              }
            }
          }

          .login-btn {
            width: 100%;
            height: 45px;
            background: #005EEC;
            color: white;
            border: none;
            border-radius: 4px;
            font-size: 16px;
            cursor: pointer;
            margin-top: 20px;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              background: #66b1ff;
              transform: translateY(-1px);
              box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
            }
          }
        }
      }
    }
  }
}

.info-confirm-dialog {
  .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      display: flex;
      align-items: center;
    }
  }

  .el-dialog__body {
    padding: 20px;

    .el-form-item {
      margin-bottom: 16px;

      .el-form-item__label {
        color: #666;
        font-size: 14px;
        line-height: 32px;
      }

      .info-value {
        color: #333;
        font-size: 14px;
        line-height: 32px;
      }
    }
  }

  .el-dialog__footer {
    padding: 16px 20px 20px;
    text-align: center;

    .dialog-footer {
      .el-button {
        min-width: 80px;
        margin: 0 6px;
      }
    }
  }
}

// 推荐组长弹窗样式
.recommend-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.recommend-dialog {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 500px;
  max-width: 90vw;
}

.recommend-dialog-content {
  text-align: start;
  padding: 20px;

  // 标题栏
  .recommend-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .title-section {
      display: flex;
      align-items: center;

      .title-bar {
        width: 4px;
        height: 20px;
        background-color: #409EFF;
        margin-right: 10px;
        border-radius: 2px;
      }

      .dialog-title {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
        color: #333;
      }
    }

    .new-file-btn {
      background-color: #409EFF;
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #66b1ff;
      }
    }
  }

  // 提示文字
  .instruction-text {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
    line-height: 1.5;
  }

  // 选择选项
  .selection-options {
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .expert-card {
      padding: 16px;
      background-color: #f8f9fa;
      border: 2px solid #e0e0e0;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background-color: #e8f4ff;
        border-color: #409EFF;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
      }

      &.active {
        border-color: #409EFF;
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);

        .expert-name {
          color: white;
        }

        .expert-details {

          .expert-unit,
          .expert-title {
            color: rgba(255, 255, 255, 0.9);
          }
        }
      }

      .expert-info {
        .expert-name {
          font-size: 16px;
          font-weight: 600;
          color: #333;
          margin-bottom: 8px;
        }

        .expert-details {

          .expert-unit,
          .expert-title {
            font-size: 14px;
            color: #666;
            line-height: 1.4;
            margin-bottom: 4px;

          }
        }
      }
    }
  }

  // 保存按钮
  .save-section {
    text-align: center;

    .save-btn {
      width: 120px;
      height: 40px;
      background-color: #409EFF;
      color: white;
      border: none;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.3s;

    }
  }
}

// 推荐结果弹窗样式
.result-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.result-dialog {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 500px;
  max-width: 90vw;
}

.result-dialog-content {
  text-align: start;
  padding: 20px;

  // 标题栏
  .result-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .title-section {
      display: flex;
      align-items: center;

      .title-bar {
        width: 4px;
        height: 20px;
        background-color: #409EFF;
        margin-right: 10px;
        border-radius: 2px;
      }

      .dialog-title {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
        color: #333;
      }
    }
  }

  // 候选人展示
  .candidates-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin-bottom: 20px;

    .candidate-item {
      background-color: #f5f5f5;
      border: 1px solid #e0e0e0;
      border-radius: 6px;
      text-align: center;

      .candidate-name {
        font-size: 14px;
        color: #333;
        margin-bottom: 8px;
        font-weight: 500;
      }

      .vote-count {
        width: 100%;
        background-color: rgba(7, 221, 218, 1);
        padding: 8px;
        font-size: 12px;
        display: inline-block;
      }
    }
  }

  // 投票结果
  .vote-result {
    margin-bottom: 20px;

    .result-text {
      background-color: #fff2f0;
      border: 1px solid #ffccc7;
      border-radius: 6px;
      padding: 12px 16px;
      font-size: 14px;
      color: #ff4d4f;
      text-align: center;
      font-weight: 500;
    }
  }

  // 开始评标按钮
  .start-section {
    text-align: center;

    .start-btn {
      width: 120px;
      height: 40px;
      background-color: #409EFF;
      color: white;
      border: none;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
    }
  }


}

// 预览文件弹窗样式
.preview-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.preview-dialog {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90vw;
  max-width: 1200px;
  height: 80vh;
  max-height: 800px;
  display: flex;
  flex-direction: column;
}

.preview-dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  // 标题栏
  .preview-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;

    .title-section {
      display: flex;
      align-items: center;

      .title-bar {
        width: 4px;
        height: 20px;
        background-color: #409EFF;
        margin-right: 10px;
        border-radius: 2px;
      }

      .dialog-title {
        margin: 0;
        font-size: 18px;
        font-weight: 500;
        color: #333;
      }
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 24px;
      color: #999;
      cursor: pointer;
      padding: 0;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  // 文件选择区域
  .file-selection-section {
    margin-bottom: 20px;

    .selection-row {
      display: flex;
      align-items: center;
      gap: 15px;

      .selection-label {
        font-size: 14px;
        color: #666;
        white-space: nowrap;
      }

      .file-radio-group {
        display: flex;
        gap: 10px;
      }

      .company-select {
        width: 200px;
      }
    }
  }

  // 预览内容区域
  .preview-content {
    flex: 1;
    margin-bottom: 20px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
  }

  // 操作按钮
  .preview-actions {
    text-align: center;

    .recommend-btn {
      background-color: #409EFF;
      color: white;
      border: none;
      border-radius: 4px;
      padding: 10px 20px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
    }
  }
}
</style>